// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"537a2ff8","349":"609bb4a4","453":"779744fd","463":"a53f042d","566":"4c72a913","680":"456b50f8","698":"f18be2a2","780":"17028adb","819":"45aa8033","850":"4f038ca6","890":"d8152fc4","892":"e9978aa3","971":"9de1f0fc"}[chunkId] + ".chunk.js";
};